module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-60x60-3984682114705c7c8d79fe98d7d0095e.png";